import isNil from 'lodash/isNil'
import React from 'react'
import { InlineInput } from '../InlineInput'
import { PhoneNumberInput } from './PhoneNumberInput'
import { InlineDisplayEmptyContent } from '../InlineInput/InlineDisplayEmptyContent'
import { PhoneNumberDisplay } from './PhoneNumberDisplay'
import { formatPhoneNumber, validatePhoneNumber } from '@ztechapps/common.utils'

const defaultDisplayContent = (value) => {
  return !isNil(value) ? <PhoneNumberDisplay value={value} /> : <InlineDisplayEmptyContent />
}

const validate = async (value: string) => {
  validatePhoneNumber(value)
}

export const PhoneNumberInlineInput = ({
  parentInputComponent,
  name,
  inputProps,
  updateParams,
  displayContent,
  ...rest
}) => {
  const ParentInput = parentInputComponent || InlineInput
  updateParams =
    updateParams ??
    (({ updatedValue, _id }) => ({
      input: {
        _id,
        [name]: formatPhoneNumber(updatedValue),
      },
    }))

  return (
    <ParentInput
      {...{
        ...rest,
        name,
        updateParams,
        displayContent: displayContent ?? defaultDisplayContent,
        editContent: (props) => <PhoneNumberInput {...{ ...props, ...inputProps }} />,
        validate,
      }}
    />
  )
}
